import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

type Props = {
    height: string,
    width: string,
    borderRadius: string,
    backgroundColor: string,
    progressColor?: boolean | string,
    inProgress: boolean
}

const AnimatedProgressBar = (props: Props) => {
    const {
        height,
        width,
        borderRadius,
        backgroundColor,
        progressColor,
        inProgress
    } = props

    const [state, setState] = useState({
        animatedWidth: '0%',
        isAnimated: false
    })
    const { animatedWidth, isAnimated } = state

    const animationTime = 2000

    useEffect(() => {
        const interval = setInterval(() => {
            animation()
        }, animationTime)
        return () => clearInterval(interval)
    }, [animatedWidth, isAnimated])

    const animation = () => {
        setState({
            animatedWidth: '100%',
            isAnimated: true
        })
        setTimeout(() => {
            setState({
                animatedWidth: '0%',
                isAnimated: false
            })
        }, animationTime - 10)
    }

    return (
        <FullSegment
            height={height}
            width={width}
            borderRadius={borderRadius}
            backgroundColor={backgroundColor}
            progressColor={inProgress ? backgroundColor : progressColor}>
            {inProgress && (
                <AnimatedGauge
                    height={height}
                    progressColor={progressColor}
                    borderRadius={borderRadius}
                    width={animatedWidth}
                    isAnimated={isAnimated}
                />
            )}
        </FullSegment>
    )
}

export { AnimatedProgressBar }

const FullSegment = styled.div`
    flex-grow: 1;
    height: ${props => props.height};
    width: ${props => props.width};
    background-color: ${props =>
        props.progressColor ? props.progressColor : props.backgroundColor};
    border-radius: ${props => props.borderRadius};
    margin-right: 5px;
`

const AnimatedGauge = styled.div`
    height: ${props => props.height};
    background-color: ${props => props.progressColor};
    border-radius: ${props => props.borderRadius};
    width: ${props => props.width};
    ${props => props.isAnimated && 'transition: width 2s linear'}
`
